<template>
  <div class="image-pick-item pa-2">
    <v-img position="top center" :lazy-src="url" :src="url" contain></v-img>
    <div>
      <h4>{{ capitalize(image_title) }}</h4>
      <p>
        <KeywordRow :keywords="keywords" />
      </p>
      <h4>Copyright</h4>
      <p>{{ image_copyright }}</p>
      <h4>Typ</h4>
      <p class="image-type">
        {{ type }}
        <v-avatar v-if="image_type === 'restricted'" class="ml-2" color="red" size="20"
          ><v-icon color="white">mdi-exclamation</v-icon></v-avatar
        >
      </p>
    </div>
    <v-btn class="add-button" fab small color="primary" @click="onSelect">
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
  </div>
</template>

<script>
import KeywordRow from '@/components/shared/KeywordRow.vue'

export default {
  name: 'ImagePickItem',
  props: {
    id: { type: Number },
    image_title: { type: String },
    image_keywords: { type: String },
    image_copyright: { type: String },
    image_type: { type: String },
    image_text: { type: String },
  },
  components: {
    KeywordRow,
  },
  data() {
    return {
      imageRightsOptions: [
        { id: 'public', title: 'Allmänt tillgänglig' },
        { id: 'restricted', title: 'Begränsad tillgång' },
        { id: 'azote', title: 'Azote Library' },
      ],
    }
  },
  computed: {
    type() {
      return (
        this.imageRightsOptions.find((item) => item.id === this.image_type)?.title || 'Ospecifcerad'
      )
    },
    url() {
      return `${process.env.VUE_APP_IMAGE_BACKEND}/170/${this.id}.jpg`
    },
    keywords() {
      return this.image_keywords
    },
  },
  methods: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    onSelect() {
      const url = `${process.env.VUE_APP_IMAGE_BACKEND}/1170/${this.id}.jpg`
      this.$emit('select', {id:this.id, url, alt: this.image_text || this.image_title })
    },
  },
}
</script>

<style lang="less" scoped>
.image-pick-item {
  position: relative;
  display: grid;
  grid-template-columns: 30% 1fr;
  grid-template-rows: 1fr auto;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  border: #ccc 1px solid;
  border-radius: 6px;
  cursor: pointer;
  p {
    margin-bottom: 2px;
  }
  .image-type {
    display: flex;
    // i{
    //   margin-left: -4px;
    // }
  }
  .add-button {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }
}
</style>
